const PUBLIC_PATHS = new Set(['/login', '/auth/verify']);

export function safeReturnTo(search: string): string {
  const value = new URLSearchParams(search).get('returnTo');
  if (
    !value ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\') ||
    /%5c/i.test(value)
  ) {
    return '/';
  }
  try {
    const target = new URL(value, window.location.origin);
    if (target.origin !== window.location.origin || PUBLIC_PATHS.has(target.pathname)) {
      return '/';
    }
    return `${target.pathname}${target.search}`;
  } catch {
    return '/';
  }
}
